<app-print-assest-qr-details></app-print-assest-qr-details>
